import { IconButton, Stack, StackProps, Typography, TypographyProps } from '@mui/material';
import { FC, ReactNode, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { CopyIcon, DoneIcon } from '../../assets/icons';

type CopyActionProps = {
  onCopy: () => Promise<void>;
  durationMs?: number;
  text?: ReactNode;
  textVariant?: TypographyProps['variant'];
} & StackProps;

export const CopyAction: FC<CopyActionProps> = ({
  onCopy,
  durationMs = 150,
  text,
  textVariant,
  className,
  sx,
  ...props
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const { formatMessage } = useIntl();

  const handleCopy = useCallback(async () => {
    try {
      await onCopy();
      setTimeout(() => {
        setIsCopied(true);
      }, durationMs);
    } catch {}
  }, [durationMs, onCopy]);

  return (
    <Stack
      onClick={handleCopy}
      direction="row"
      alignItems="center"
      gap={1}
      {...props}
      className={[isCopied ? 'copied' : 'not-copied', className].filter(Boolean).join(' ')}
      sx={{ cursor: 'pointer', '&:hover > *': { color: 'common.grey2' }, ...sx }}
    >
      <IconButton>{isCopied ? <DoneIcon /> : <CopyIcon />}</IconButton>
      <Typography variant={textVariant}>
        {text ? text : formatMessage({ id: 'action-Copy' })}
      </Typography>
    </Stack>
  );
};
